import { render, staticRenderFns } from "./error.vue?vue&type=template&id=4c9cf96e&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,InschrijvingNavigation: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/navigation.vue').default})
